import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, EmptyState, formatDate, formatCurrency } from "@/components/pcp";
import { PROP_STATUS, StatusProposta } from "@/components/comercial/comercialUtil";
import { useEmpresaAtiva } from "@/components/EmpresaSelector";
import { ArrowRight, TrashSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Propostas() {
  const [items, setItems] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [fStatus, setFStatus] = useState("");
  const ativa = useEmpresaAtiva();
  const [fEnt, setFEnt] = useState(ativa || "");
  useEffect(() => { setFEnt(ativa || ""); }, [ativa]);
  const nav = useNavigate();
  const load = () => Promise.all([api.get("/propostas"), api.get("/empresas")]).then(([p, e]) => { setItems(p.data); setEmpresas(e.data); });
  useEffect(() => { load(); }, []);
  const excluir = async (e, p) => {
    e.stopPropagation();
    if (!window.confirm(`Excluir a proposta ${p.numero}?`)) return;
    try { await api.delete(`/propostas/${p.id}`); toast.success("Proposta excluída"); load(); } catch (err) { toast.error(err.response?.data?.detail || "Erro ao excluir"); }
  };
  const porEnt = items.filter((p) => !fEnt || p.entidade_id === fEnt);
  const vis = porEnt.filter((p) => !fStatus || p.status === fStatus);
  const total = (lst) => lst.reduce((s, p) => s + (p.valor || 0), 0);
  return (
    <>
      <PageHeader testid="page-propostas" title="Propostas" subtitle={`Módulo Comercial — ${items.filter((p) => p.status === "enviada").length} aguardando resultado · ${formatCurrency(total(items.filter((p) => p.status === "enviada")))} em aberto`} />
      <div className="page-body">
        <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap" }} data-testid="propostas-filtros">
          <select className="select" value={fEnt} onChange={(e) => setFEnt(e.target.value)} style={{ width: "auto", minWidth: 200, height: 30, padding: "0 28px 0 8px", fontSize: "0.78rem" }} data-testid="proposta-filtro-entidade">
            <option value="">Todas as entidades ({items.length})</option>
            {empresas.map((e) => <option key={e.id} value={e.id}>{e.tipo === "consorcio" ? "Consórcio · " : ""}{e.nome} ({items.filter((p) => p.entidade_id === e.id).length})</option>)}
          </select>
          <button className={`chip ${!fStatus ? "chip-active" : ""}`} onClick={() => setFStatus("")}>Todas ({porEnt.length})</button>
          {Object.entries(PROP_STATUS).map(([k, v]) => <button key={k} className={`chip ${fStatus === k ? "chip-active" : ""}`} onClick={() => setFStatus(k)} data-testid={`proposta-filtro-${k}`}>{v} ({porEnt.filter((p) => p.status === k).length})</button>)}
        </div>
        {vis.length === 0 ? <EmptyState title="Nenhuma proposta" description="As propostas são emitidas a partir de um orçamento concluído (Orçamentos → Emitir proposta)." /> : (
          <div className="pcp-card" style={{ overflowX: "auto" }}>
            <table className="pcp-table" data-testid="propostas-table">
              <thead><tr><th>Status</th><th>Número</th><th>Cliente</th><th>Entidade</th><th>Emissão</th><th>Envio</th><th>Resultado</th><th style={{ textAlign: "right" }}>Valor</th><th>Contrato</th><th /></tr></thead>
              <tbody>
                {vis.map((p) => (
                  <tr key={p.id} onClick={() => nav(`/propostas/${p.id}`)} style={{ cursor: "pointer" }} data-testid={`proposta-row-${p.id}`}>
                    <td><StatusProposta status={p.status} /></td>
                    <td className="font-mono font-semibold">{p.numero}</td>
                    <td>{p.contratante}</td>
                    <td style={{ fontSize: "0.78rem" }}>{empresas.find((e) => e.id === p.entidade_id)?.nome || "—"}</td>
                    <td className="font-mono text-xs">{formatDate(p.data_emissao)}</td>
                    <td className="font-mono text-xs">{formatDate(p.data_envio)}</td>
                    <td className="font-mono text-xs">{formatDate(p.data_resultado)}</td>
                    <td className="font-mono" style={{ textAlign: "right" }}>{formatCurrency(p.valor)}</td>
                    <td className="font-mono text-xs">{p.contrato_id ? <span style={{ color: "#047857", fontWeight: 600 }}>gerado</span> : "—"}</td>
                    <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                      {["elaborada", "cancelada", "perdida"].includes(p.status) && !p.contrato_id && <button className="btn btn-ghost btn-sm" onClick={(e) => excluir(e, p)} title="Excluir proposta" data-testid={`btn-excluir-proposta-${p.id}`} style={{ color: "#DC2626", marginRight: 4 }}><TrashSimple size={14} weight="bold" /></button>}
                      <ArrowRight size={14} weight="bold" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
